module.exports = __webpack_public_path__ + "img/plus_icon.aa998237.png";